module.exports = __webpack_public_path__ + "img/hardware_device.c922fa38.jpg";